<div class="section-header">
  <ng-content select="[condition-info-section-header]" />
</div>

<div class="section-content">
  <ng-content />
</div>
